import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/app',
  base: process.env.NODE_ENV === "development" ? '/' : '/app',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/joinPage',
      meta: {
        title: '首页',
        auth:false,// 是否需要登录
      },
      component: () => import('@/views/index')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录页',
        auth:false,// 是否需要登录
      },
      component: () => import('@/views/login')
    },
    {
      path: '/joinPage',
      name: 'JoinPage',
      meta: {
        title: "超浔黑鸭加盟"
      },
      component: () => import('../views/joinPage/index.vue')
    },
    {
      path: "/404",
      name: "notFound",
      meta: {
        title: '404',
        auth:false,// 不需要登录
      },
      component: () => import('../views/404.vue')
    }, 
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404"
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js